// extracted by mini-css-extract-plugin
module.exports = {"container":"IconButton_container_2bpvC","text":"IconButton_text_2oz-1","spinAround":"IconButton_spinAround_h3SbB"};